import { Box, Button, Card, Group, Stack, Text, List, Divider } from '@mantine/core';
import { FormPageLayout, PlatformLoader } from '@flexinet/ui-components';
import { useCreateSubscription } from '../hooks/useCreateSubscription';

export const CreateSubscriptionPage = () => {
    const {
        product,
        displayAmount,
        displayPeriod,
        loading,
        createSubscription,
        isCreating,
        handleCancel
    } = useCreateSubscription();

    if (loading) {
        return <PlatformLoader message="Loading subscription details..." />;
    }

    return (
        <FormPageLayout title="Review Subscription" pageNavigation={<Box />}>
            <Stack gap="lg" p="md" maw={800} mx="auto">
                <Card withBorder p="xl" shadow="sm">
                    <Stack gap="lg">
                        <Text size="28px" fw={700}>{product?.name}</Text>
                        
                        {product?.longDescription && (
                            <Text size="md" c="dimmed">{product.longDescription}</Text>
                        )}

                        <Divider my="md" />

                        <Group justify="space-between" align="center">
                            <Text size="lg" fw={500}>Subscription Price</Text>
                            <Text size="32px" fw={700} c="blue">
                                ${displayAmount.toFixed(2)}
                                <Text component="span" size="lg" fw={400} c="dimmed"> / {displayPeriod}</Text>
                            </Text>
                        </Group>

                        {product?.lineItems?.items && product.lineItems.items.length > 0 && (
                            <>
                                <Divider my="md" />
                                <Stack gap="md">
                                    <Text size="lg" fw={600}>What's Included:</Text>
                                    <List size="md" spacing="sm">
                                        {product.lineItems.items.map((item: any) => (
                                            <List.Item key={item.id}>
                                                <Text size="md">{item.productFeature?.name}</Text>
                                                {item.productFeature?.description && (
                                                    <Text size="sm" c="dimmed">{item.productFeature.description}</Text>
                                                )}
                                            </List.Item>
                                        ))}
                                    </List>
                                </Stack>
                            </>
                        )}

                        <Divider my="md" />

                        <Group justify="space-between" mt="lg">
                            <Button variant="light" size="lg" onClick={handleCancel}>
                                Cancel
                            </Button>
                            <Button
                                onClick={() => createSubscription()}
                                loading={isCreating}
                                size="lg"
                            >
                                Subscribe Now
                            </Button>
                        </Group>
                    </Stack>
                </Card>
            </Stack>
        </FormPageLayout>
    );
};
